/**
 * Constants
 * @object
 */

const config = {};

const actions = {
  SET_CATEGORY: 'SET_CATEGORY',
  SHOW_CATEGORY_OPTIONS: 'SHOW_CATEGORY_OPTIONS',
  HIDE_CATEGORY_OPTIONS: 'HIDE_CATEGORY_OPTIONS',
  WINDOW_RESIZE: 'WINDOW_RESIZE',
  BRING_TO_CENTER: 'BRING_TO_CENTER',
  SHOW_TEAMS_SORT_BUTTON: 'SHOW_TEAMS_SORT_BUTTON',
  SHOW_TEAMS_HEADERS: 'SHOW_TEAMS_HEADERS',
  TEAM_1_ROWS: 'TEAM_1_ROWS',
  TEAMS_EVEN_ROWS: 'TEAMS_EVEN_ROWS',
  MAX_PLAYER_COUNT: 'MAX_PLAYER_COUNT',
  OPEN_MODAL: 'OPEN_MODAL',
  TRANSITION_OUT_MODAL: 'TRANSITION_OUT_MODAL',
  TRANSITION_IN_MODAL: 'TRANSITION_IN_MODAL',
  CLOSE_MODAL: 'CLOSE_MODAL',
  SET_MODAL_DATA: 'SET_MODAL_DATA',
};

const constants = Object.assign(config, actions);

export default constants;
